import moment from "moment"

export default {
  formattedDateTime(value) {
    return moment(value).format('DD MMM YY, HH:mm a');
  },
  formattedDateTimeShort(value) {
    return moment(value).format('DD MMM');
  },
  formattedDayDifference(from, to) {
    return moment(to).diff(moment(from), 'days');
  },
};
